import sportEvents from '@/store/modules/sport-events/sport-events'
import sportEventsList from '@/store/modules/sport-events/sport-events-list'
import sportEventCreate from '@/store/modules/sport-events/sport-event-create'
import sportEventEdit from '@/store/modules/sport-events/sport-event-edit'
import sportEventDelete from '@/store/modules/sport-events/sport-event-delete'
import sportEventComments from '@/store/modules/sport-events/sport-events-comments'
import sportEventListAdmin from '@/store/modules/sport-events/sport-events-list-admin'
import readComments from '@/store/modules/sport-events/read-comments'

export default {
  sportEvents,
  sportEventsList,
  sportEventCreate,
  sportEventEdit,
  sportEventDelete,
  sportEventComments,
  sportEventListAdmin,
  readComments,
}
